/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import DialogModal from "../DialogModal/DialogModal";
import { DialogProps } from "@mui/material/Dialog/Dialog";

type PensionsCostCalculatorModalProps = {
  open: boolean;
  onClose: () => void;
} & DialogProps;

const PensionsCostCalculatorModal = ({ open, onClose, ...rest }: PensionsCostCalculatorModalProps) => {
  return (
    <DialogModal title={"Versorgungsausgleich"} open={open} onClose={onClose} {...rest}>
      <p>
        Bei einer Scheidung führt das Gericht immer den Versorgungsausgleich durch. Hierbei geht es um die Teilung der Rentenansprüche der Eheleute aus der
        Ehezeit. Im Normalfall geht es um den Ausgleich von 2 Rentenansprüchen: je eine gesetzliche Rentenversicherung pro Ehepartner. Sollten Sie zum Beispiel
        zusätzlich eine private Rentenversicherung (betriebliche Altersvorsorge oder Riesterrente) haben, geben Sie bei “Ihre Rentenversicherungen” eine 2 an.
      </p>
      <p>
        Wenn die Ehe bis zur gerichtlichen Zustellung des Scheidungsantrages weniger als drei Jahre bestanden hat, muss der Versorgungsausgleich nicht
        stattfinden. In allen anderen Fällen muss der Versorgungsausgleich durchgeführt werden, außer die Eheleute schließen den Versorgungsausgleich aus.
      </p>
      <p>
        Wenn Sie per Notar auf den Ausgleich verzichten möchten, oder Ihre Ehe weniger als drei Jahre bestanden hat, klicken Sie bitte "Versorgungsausgleich
        ausschließen" an.
      </p>
    </DialogModal>
  );
};

export default PensionsCostCalculatorModal;
